import Vue from 'vue'

const VueUploadComponent = require('vue-upload-component')

Vue.component('file-upload', VueUploadComponent)
